<template>
  <div class="exchange-order-page" v-cloak>
    <van-nav-bar left-arrow fixed title="兑换订单" id="nav-bar" @click-left="onClickLeft">
    </van-nav-bar>

    <div class="tabs">
      <van-tabs v-model="active" title-active-color="#00A8C0" title-inactive-color="#78849E" color="#00A8C0" z-index="100" @change="onChange">
        <van-tab v-for="(item, index) in table" :key="index" :title="item"></van-tab>
      </van-tabs>
    </div>

    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="initData">
        <img-text-order v-for="(item, index) in list" :key="index" :info="item"></img-text-order>
      </van-list>
    </div>

    <van-empty class="custom-image" v-if="list.length< 1" image="https://qiniu.zdyxjx.com/v3/pic/ad5943d2fb384cae9d8bf0b7867893e4.png" />

  </div>
</template>

<script>
import imgTextOrder from "@/components/img-text-exchange-order/img-text-exchange-order.vue";

export default {
  name: "ProductList",
  components: { imgTextOrder },
  props: {},
  data() {
    return {
      active: 0,
      pageNum: 1,
      pageSize: 10,
      state: '',
      table: ["全部", "未付款", "未发货", "待收货"],
      list: [
        // {
        //   id: "1",
        // state: 1, //1 未付款 2 已付款 未发货 3 待收货 4 已完成  5 易关闭
        // // -1：已取消，0：未支付，1：已支付待发货，2：已发货
        // goodsAmount: 0,
        // totalAmount: 0,
        // payAmount: 0,
        // actEndTime: "20202020",
        // products: [
        //   {
        //     productId: 0,
        //     skuId: 0,
        //     productName: "string",
        //     productImage: "string",
        //     sku: "string",
        //     quantity: 0,
        //     salePrice: 0,
        //     freeAmount: 0,
        //     payAmount: 0,
        //     supplierName: "string",
        //   },
        // ],
        // },
      ],

      loading: false,
      finished: false,
    };
  },
  watch: {},
  created() { },
  mounted() {

  },
  methods: {
    // table切换
    onChange(event) {
      // console.log(event);
      let stateData = "";
      if (event == 1) {
        stateData = 0;
        //-1：已取消，0：未支付，1：已支付待发货，2：已发货
      } else if (event == 2) {
        stateData = 1;
      } else if (event == 3) {
        stateData = 2;
      }
      this.loading = true;
      this.finished = false;
      this.list = [];
      this.pageNum = 1;
      this.state = stateData;

      this.initData();
    },
    // 初始化数据
    initData() {
      let _this = this;
      console.log(this.state)
      this.$get("/order/api/Order/MyOrder",
        {
          type: 0,  //0：兑换订单，1：商城订单 
          state: _this.state,
          Page: _this.pageNum,
          Size: _this.pageSize,
        }
      ).then((res) => {
        this.loading = false; // 加载状态结束

        if (res.data.code == 200) {
          let lists = res.data.data.records;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.list = lists;
            } else {
              _this.list = _this.list.concat(lists);
            }
            _this.pageNum++;

            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            this.finished = true; // 数据全部加载完成
          }
        } else {
          this.$toast.fail(res.data.message);
          this.finished = true;
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.exchange-order-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style> 

<style lang="scss" scoped>
.tabs {
  position: fixed;
  /* top: 30rpx; */
  background-color: #fff;
  top: 46px;
  left: 0;
  width: 100%;
  z-index: 100;
}
.exchange-order-page {
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 96px 0 0;
  box-sizing: border-box;

  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */

  .list {
    padding: 0 10px 10px;
    box-sizing: border-box;
  }
}
</style>
